module.exports = __webpack_public_path__ + "static/a-geography-of-time-a0087b6ee3f497fdfdc0aa7f2904d0fd.jpg";